import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { get, sess_get } from 'utils/HttpRequests';
import PreLoader from 'components/Others/PreLoader';
import moment from 'moment';

export default function RewardsList(props) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [remainingBudget, setRemainingBudget] = useState(0);
  const [totalBudget, setTotalBudget] = useState(0);
  const history = useHistory();

  useEffect(() => {
    setLoading(true);
    sess_get('admin/console/all-flights', localStorage.getItem('admin-panel-sessionToken'))
      .then((res) => {
        setList(res?.data?.response?.allFlightsList);
        setRemainingBudget(res?.data?.response?.remaining_budget);
        setTotalBudget(res?.data?.response?.total_budget);
        setLoading(false);
      })
      .catch((err) => { console.log('err'); setLoading(false); });
  }, []);

  const viewRewardsDetails = (id) => {
    history.push(`/rewards?id=${id}`);
  };

  return (
    <div style={{ width: '80%', margin: '40px auto' }}>
      {loading && <PreLoader />}
      <div style={{
        display: 'flex', flexDirection: 'row', justifyContent: 'space-between', margin: '20px',
      }}
      >
        <h1>Rewards</h1>

        <button className="btn btn-primary" onClick={() => props.createNew()}>Create new</button>
      </div>
      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
        <div style={{
          border: '1px solid black', borderRadius: '6px', padding: '10px', textAlign: 'right',
        }}
        >
          <h5>System available budget</h5>
          &#8377;
          {' '}
          {totalBudget || '-'}
        </div>
        <div style={{
          border: '1px solid black', borderRadius: '6px', padding: '10px', textAlign: 'right',
        }}
        >
          <h5>System remaining budget</h5>
          &#8377;
          {' '}
          {remainingBudget || '-'}
        </div>
      </div>
      <table style={{ width: '100%' }}>
        <tr style={{ fontSize: '20px' }}>
          <th>Flight_Id</th>
          <th>Name</th>
          <th>Method</th>
          <th>Priority</th>
          <th>Avail Count</th>
          <th>Utilized Budget</th>
          <th>Remaining Budget</th>
          <th>Expiry Date</th>
          <th>Status</th>
          <th>Details</th>
        </tr>
        {
          list.map((item) => (
            <tr key={item._id} style={{ fontSize: '16px' }}>
              <td>{item._id}</td>
              <td>{item.name}</td>
              <td>{item.method}</td>
              <td>{item.priority}</td>
              <td>{item.avail_count}</td>
              <td>{item.allotted_budget - item.remaining_budget}</td>
              <td>{item.remaining_budget}</td>
              <td>{moment(item?.end_date).format('DD-MM-YYYY')}</td>
              <td>{item.status}</td>
              <td>
                <button onClick={() => viewRewardsDetails(item._id)} className="btn btn-primary"> View details</button>
              </td>
            </tr>
          ))
        }
      </table>
    </div>
  );
}
